import { cache } from "../persistence/cache";
import defaults from "../../constants";

/**
 * @module web/store
 * @private
 */

const PROFILE_ID = "";
let profileId = null;

/**
 * Update the user profileId related data, by storing it in memory.
 * @param {Object} newProfileId - An object containing user profileId data obtained from a request through a backend call.
 * @public
 */
const update = function(newProfileId) {
  profileId = newProfileId;
};

/**
 * Returns the current user profileId related data object stored in memory, where it will be searched for.
 * @returns {Object} - A found stored profileId related data object or null if not found in memory.
 * @public
 */
const get = async function(self, sendMasterProfileDataInHeaders) {
  const _this = self;

  let cachedUser = null;

  if (sendMasterProfileDataInHeaders) {
    // for logged in
    if (_this.localCache && _this.localCache.auth) {
      cachedUser = await cache.get("user", { database: "auth" });
    }

    const user = cachedUser && cachedUser.user && cachedUser.user;
    if (user && user.profiles && user.profiles.length) {
      // FIX ME
      // get the desired profile category,rather than the master profile every time
      const masterProfile = user.profiles.find(item => item.isMasterProfile);
      profileId = masterProfile ? masterProfile.profileId : user.globalUserId;
    }
  } else {
    if (_this.localCache && _this.localCache.auth) {
      cachedUser = await cache.get("currentProfile", { database: "auth" });
    }

    if (cachedUser && cachedUser.profileId) {
      // FIX ME
      // get the desired profile category,rather than the master profile every time
      profileId = cachedUser.profileId;
    } else {
      cachedUser = await cache.get("user", { database: "auth" });
      profileId = cachedUser.globalUserId;
    }
  }

  // for guest, in case auth db in not used like web client
  if (!profileId) {
    const guestProfie = _this.guestProfie();
    profileId = guestProfie?.profileId || PROFILE_ID;
  }
  return profileId;
};

export default { update, get };
